import Vue from "vue";
import VueRouter from "vue-router";

import Basics from "../views/Basics.vue";
import Login from "../views/Login.vue";

import Home from "../views/Home.vue";

//-------------------------------------系统设置------------------------------------------
// 系统参数管理
import SystemParameter from "../views/system/SystemParameter.vue";
// 职责管理
import Duty from "../views/system/Duty.vue";
// 产品分类
import ProductCategory from "../views/system/ProductCategory.vue";

//-------------------------------------组织架构管理------------------------------------------
// 企业管理
import Enterprise from "../views/organization/Enterprise.vue";
// 职位管理
import Position from "../views/organization/Position.vue";
// 部门管理
import Department from "../views/organization/Department.vue";
// 部门管理
import Staff from "../views/organization/Staff.vue";

//-------------------------------------服务商管理------------------------------------------
// 服务商设置
import Facilitator from "../views/facilitator/Facilitator.vue";
//设备类型
import Devicetype from "../views/facilitator/Devicetype.vue";
//设备类型
import Businesstype from "../views/facilitator/Businesstype.vue";
//设备类型
import Crowdtype from "../views/facilitator/Crowdtype.vue";
//表单模板
import FormTemplate from "../views/facilitator/FormTemplate.vue";

//-------------------------------------票务信息设置------------------------------------------
//----------------产品管理
//基础票
import BasicTicket from "../views/ticketInfo/BasicTicket.vue";
//价格管理
import PriceManage from "../views/ticketInfo/PriceManage.vue";
//库存设置
import InventorySettings from "../views/ticketInfo/InventorySettings.vue";
//库存详情
import InventoryDetails from "../views/ticketInfo/InventoryDetails.vue";
//产品黑名单
import BlackList from "../views/ticketInfo/BlackList.vue";

//----------------优惠政策管理
//优惠政策
import PriceDiscount from "../views/ticketInfo/PriceDiscount.vue";
//优惠详情
import PriceDiscountDetails from "../views/ticketInfo/PriceDiscountDetails.vue";

//-------------------------------------票务销售设置------------------------------------------
//售票站点
import TicketStation from "../views/ticketSales/TicketStation.vue";
//售票窗口
import TicketWindow from "../views/ticketSales/TicketWindow.vue";
//售票窗口
import Salewindow from "../views/ticketSales/Salewindow.vue";
//员工售票权限
import Salestaff from "../views/ticketSales/Salestaff.vue";

//-------------------------------------检票设置------------------------------------------
//园门管理
import CheckStation from "../views/ticketCheck/CheckStation.vue";
//关联园门
import CheckStationCorrelation from "../views/ticketCheck/CheckStationCorrelation.vue";

//准进设备
import Checkdevice from "../views/ticketCheck/Checkdevice.vue";
// 设备权限
import SaleCheckDevice from "../views/ticketCheck/SaleCheckDevice.vue";
// 检票权限
import CheckPermission from "../views/ticketCheck/CheckPermission.vue";

//-------------------------------------线下售检数据报表------------------------------------------
//售票流水查询
import TicktingFlow from "../views/offlineReport/TicketingFlow.vue";
//检票流水查询
import CheckFlow from "../views/offlineReport/CheckFlow.vue";
//订单详情
import OrderDetails from "../views/offlineReport/OrderDetails.vue";
//售票员销售报表
import StaffReport from "../views/offlineReport/StaffReport.vue";
//售票统计表
import TicketSalesReport from "../views/offlineReport/TicketSalesReport.vue";
//检票统计表
import TicketCheckReport from "../views/offlineReport/TicketCheckReport.vue";
//售票员销售报表
import TicketStaffReport from "../views/offlineReport/TicketStaffReport.vue";
//商品销售报表
import ProductReport from "../views/offlineReport/ProductReport.vue";

//预设模板查询
import PrepareQueryPreset from "../views/offlineReport/PrepareQueryPreset.vue";
//预设模板查询配置
import PrepareQueryManage from "../views/offlineReport/PrepareQueryManage.vue";

//-------------------------------------预制票管理------------------------------------------
//仓库管理
import Pflibrary from "../views/prefabricate/Pflibrary.vue";
//票号规则
import Pfrule from "../views/prefabricate/Pfrule.vue";
//预制票详情
import PfoutDetails from "../views/prefabricate/PfoutDetails.vue";
//预制票入库
import Pfout from "../views/prefabricate/Pfout.vue";
//预制票领用
import PfoutDraw from "../views/prefabricate/PfoutDraw.vue";

//-------------------------------------自营平台------------------------------------------
//轮播图
import RollBanner from "../views/selfShop/RollBanner.vue";
//新闻资讯
import Article from "../views/selfShop/Article.vue";
//栏目管理
import Column from "../views/selfShop/Column.vue";
//推广团队
import PromotionTeam from "../views/selfShop/PromotionTeam.vue";
//推广用户
import PromotionUser from "../views/selfShop/PromotionUser.vue";
//推广海报
import PromotionPoster from "../views/selfShop/PromotionPoster.vue";

//-------------------------------------会员管理------------------------------------------
//会员列表
import memberList from "../views/member/memberList.vue";

//-------------------------------------门票打印设置------------------------------------------
//门票打印设置
import PrintTemplate from "../views/facilitator/PrintTemplate.vue";
//副卷打印设置
import PrintSubTemplate from "../views/facilitator/PrintSubTemplate.vue";

//-------------------------------------员工卡管理------------------------------------------
//员工卡列表
import StaffCard from "../views/staffCard/StaffCard.vue";
//员工卡使用记录
import StaffCardLog from "../views/staffCard/StaffCardLog.vue";

//-------------------------------------零售系统------------------------------------------
//商品管理
import ProductMall from "../views/productMall/productMall.vue";

//-------------------------------------登录日志------------------------------------------
//登录日志
import LoginLog from "../views/log/loginLog.vue";
//操作日志
import OperationLog from "../views/log/operationLog.vue";

//-------------------------------------推广数据查询------------------------------------------
//推广流水查询
import PromotionFlow from "../views/offlineReport/PromotionFlow.vue";
//推广数据报表
import PromotionReport from "../views/offlineReport/PromotionReport.vue";

//-------------------------------------数字罗盘------------------------------------------
//微信用户来源
import WxUserSource from "../views/dataChart/WxUserSource.vue";

//-------------------------------------分销商管理------------------------------------------
//分销商列表
import Distributor from "../views/distribution/distributor.vue";
import DistributorCharges from "../views/distribution/distributorCharges.vue";
import DistributorPrice from "../views/distribution/distributorPrice.vue";

Vue.use(VueRouter);

const routes = [
    { path: "/Login", name: "Login", component: Login },
    { path: "/", redirect: "/Login" },
    {
        path: "/Basics",
        name: "Basics",
        component: Basics,
        children: [
            { path: "/Home", name: "Home", component: Home },

            { path: "/SystemParameter", name: "SystemParameter", component: SystemParameter },
            { path: "/Duty", name: "Duty", component: Duty },
            { path: "/ProductCategory", name: "ProductCategory", component: ProductCategory },

            { path: "/Enterprise", name: "Enterprise", component: Enterprise },
            { path: "/Position", name: "Position", component: Position },
            { path: "/Department", name: "Department", component: Department },
            { path: "/Staff", name: "Staff", component: Staff },

            { path: "/Facilitator", name: "Facilitator", component: Facilitator },
            { path: "/Devicetype", name: "Devicetype", component: Devicetype },
            { path: "/Businesstype", name: "Businesstype", component: Businesstype },
            { path: "/Crowdtype", name: "Crowdtype", component: Crowdtype },
            { path: "/PrintTemplate", name: "PrintTemplate", component: PrintTemplate },
            { path: "/PrintSubTemplate", name: "PrintSubTemplate", component: PrintSubTemplate },

            { path: "/BasicTicket", name: "BasicTicket", component: BasicTicket },
            { path: "/PriceManage", name: "PriceManage", component: PriceManage },
            { path: "/InventorySettings", name: "InventorySettings", component: InventorySettings },
            { path: "/InventoryDetails", name: "InventoryDetails", component: InventoryDetails },
            { path: "/BlackList", name: "BlackList", component: BlackList },
            //----------------优惠政策管理
            { path: "/PriceDiscount", name: "PriceDiscount", component: PriceDiscount },
            { path: "/PriceDiscountDetails", name: "PriceDiscountDetails", component: PriceDiscountDetails },

            { path: "/TicketStation", name: "TicketStation", component: TicketStation },
            { path: "/TicketWindow", name: "TicketWindow", component: TicketWindow },
            { path: "/Salewindow", name: "Salewindow", component: Salewindow },
            { path: "/Salestaff", name: "Salestaff", component: Salestaff },

            { path: "/CheckStation", name: "CheckStation", component: CheckStation },
            { path: "/CheckStationCorrelation", name: "CheckStationCorrelation", component: CheckStationCorrelation },
            { path: "/Checkdevice", name: "Checkdevice", component: Checkdevice },
            { path: "/SaleCheckDevice", name: "SaleCheckDevice", component: SaleCheckDevice },
            { path: "/CheckPermission", name: "CheckPermission", component: CheckPermission },

            { path: "/TicktingFlow", name: "TicktingFlow", component: TicktingFlow },
            { path: "/CheckFlow", name: "CheckFlow", component: CheckFlow },
            { path: "/OrderDetails", name: "OrderDetails", component: OrderDetails },
            { path: "/StaffReport", name: "StaffReport", component: StaffReport },
            { path: "/TicketSalesReport", name: "TicketSalesReport", component: TicketSalesReport },
            { path: "/TicketCheckReport", name: "TicketCheckReport", component: TicketCheckReport },
            { path: "/TicketStaffReport", name: "TicketStaffReport", component: TicketStaffReport },
            { path: "/ProductReport", name: "ProductReport", component: ProductReport },

            { path: "/Pflibrary", name: "Pflibrary", component: Pflibrary },
            { path: "/Pfrule", name: "Pfrule", component: Pfrule },
            { path: "/PfoutDetails", name: "PfoutDetails", component: PfoutDetails },
            { path: "/Pfout", name: "Pfout", component: Pfout },
            { path: "/PfoutDraw", name: "PfoutDraw", component: PfoutDraw },

            { path: "/RollBanner", name: "RollBanner", component: RollBanner },
            { path: "/Article", name: "Article", component: Article },
            { path: "/Column", name: "Column", component: Column },
            { path: "/PromotionTeam", name: "PromotionTeam", component: PromotionTeam },
            { path: "/PromotionUser", name: "PromotionUser", component: PromotionUser },
            { path: "/PromotionPoster", name: "PromotionPoster", component: PromotionPoster },

            { path: "/FormTemplate", name: "FormTemplate", component: FormTemplate },

            { path: "/MemberList", name: "MemberList", component: memberList },
            { path: "/StaffCard", name: "StaffCard", component: StaffCard },
            { path: "/StaffCardLog", name: "StaffCardLog", component: StaffCardLog },

            { path: "/ProductMall", name: "ProductMall", component: ProductMall },

            { path: "/LoginLog", name: "LoginLog", component: LoginLog },
            { path: "/OperationLog", name: "OperationLog", component: OperationLog },

            { path: "/PromotionFlow", name: "PromotionFlow", component: PromotionFlow },
            { path: "/PromotionReport", name: "PromotionReport", component: PromotionReport },

            { path: "/WxUserSource", name: "WxUserSource", component: WxUserSource },

            { path: "/PrepareQueryPreset", name: "PrepareQueryPreset", component: PrepareQueryPreset },
            { path: "/PrepareQueryManage", name: "PrepareQueryManage", component: PrepareQueryManage },

            { path: "/Distributor", name: "Distributor", component: Distributor },
            { path: "/DistributorCharges", name: "DistributorCharges", component: DistributorCharges },
            { path: "/DistributorPrice", name: "DistributorPrice", component: DistributorPrice },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
